import { render, staticRenderFns } from "./EnvioAutomaticoView.vue?vue&type=template&id=6c9e2e53&"
import script from "./EnvioAutomaticoView.vue?vue&type=script&lang=js&"
export * from "./EnvioAutomaticoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports